// extracted by mini-css-extract-plugin
export var regionDetail = "regionDetail-module--regionDetail--4UOZI";
export var regionDetailInner = "regionDetail-module--regionDetailInner--xZyaq";
export var regionDetailScroll = "regionDetail-module--regionDetailScroll--uesCV";
export var regionHeader = "regionDetail-module--regionHeader--KHEMn";
export var effectCards = "regionDetail-module--effectCards--+tl8w";
export var slideUp = "regionDetail-module--slideUp--KvaiZ";
export var slideUpLarge = "regionDetail-module--slideUpLarge--eHSHK";